import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function Consultative() {
  return (
    <section className="consultative">
      <Breadcrumbs />

      <h1>Консультативно-диагностическое отделение</h1>
    </section>
  );
}
